import { render, staticRenderFns } from "./channelDetail.vue?vue&type=template&id=5feca090&scoped=true&"
import script from "./channelDetail.vue?vue&type=script&lang=js&"
export * from "./channelDetail.vue?vue&type=script&lang=js&"
import style0 from "./channelDetail.vue?vue&type=style&index=0&id=5feca090&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5feca090",
  null
  
)

export default component.exports